import { render, staticRenderFns } from "./DynamicEmailTemplateEditor.vue?vue&type=template&id=09e2bf82&scoped=true&"
import script from "./DynamicEmailTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./DynamicEmailTemplateEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e2bf82",
  null
  
)

export default component.exports